module.exports = __webpack_public_path__ + "img/resume-builder-sel.0ac3a656.svg";